// extracted by mini-css-extract-plugin
module.exports = {"modalAlert":"styles_modalAlert__lM3WB","linkDone":"styles_linkDone__1GMNZ"};